import { Directive } from '@angular/core';
import { QuoteService } from '../services/quote.service';
import { AbstractControl, ValidationErrors, AsyncValidator,  NG_ASYNC_VALIDATORS } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Directive({
  selector: '[appValidateItemCost]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: ItemCostValidator, multi: true }]
})
export class ItemCostValidator implements AsyncValidator  {

  constructor(private quoteService: QuoteService) { console.log("in item cost validator");}

  validate(
    ctrl: AbstractControl
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    if (ctrl.value == null) return;

    console.log("validating item cost")

      return  this.quoteService.getItem(ctrl.value).pipe(
        map(item => ( (item.item_Cost != 0 && item.item_Cost != null) ? null : { itemPriceValidator: 'Item Price is not valid' })),
      catchError(() => of(null))
   );
  }
}
